import { useParams } from 'react-router';

import { useAppSelector } from '../../../../../../store/hooks';
import { getReviewsStatsSelector } from '../../selectors/get-reviews-stats.selector';
import { ReviewSelectorsConfigModel } from './models/review-selectors-config.model';

export const useGetReviewStatisticsSelector =
  (): ReviewSelectorsConfigModel => {
    const { id: appId } = useParams();
    const stats = useAppSelector(getReviewsStatsSelector);

    return { appId, stats };
  };
